<template>
  <div>
    <SiruiSearch
      ref="formItem"
      :query="baseFormData"
      :columns="formColumn"
      :isQueryPanel="false"
      :rules="formRules"
      @changeMethod="changeMethod"
      @changeChecked="changeChecked"
    >
    </SiruiSearch>
    <!-- 预警提醒 -->
    <el-form
      :model="form"
      :rules="rules"
      ref="fromRef"
      label-width="120px"
      class="demo-ruleForm"
      size="small"
      style="padding-right: 10px"
      :disabled="isDisabledForm"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item style="">
            <template slot="label">
              <el-tooltip placement="top" effect="dark">
                <span style="color: red">预警提醒</span>
              </el-tooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="最晚提货日" prop="latestPickUpDate"
            ><template slot="label">
              <el-tooltip placement="top" effect="dark">
                <span ::class="{ propClass: tipText1>propLength }">最晚提货日</span>
                <div slot="content" v-html="tipText1"></div>
              </el-tooltip>
            </template>
            <el-date-picker
              type="date"
              v-model="form.latestPickUpDate"
              format="yyyy-MM-dd"
              style="width: 100%"
              placeholder="请选择最晚提货日"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="最晚应收结算日" prop="latestReceivableSettlementFate">
            <inputNumber
              v-model="form.latestReceivableSettlementFate"
              :controls="false"
              class="inputWidth"
              :precision="2"
              append="天"
              :min="-99999999999999999"
              :max="99999999999999999"
            ></inputNumber>
            <template slot="label">
              <el-tooltip placement="top" effect="dark">
                <span ::class="{ propClass: tipText2>propLength }">最晚应收结算日</span>
                <div slot="content" v-html="tipText2"></div>
              </el-tooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="最晚开票日" prop="latestInvoiceFate">
            <inputNumber
              v-model="form.latestInvoiceFate"
              :controls="false"
              class="inputWidth"
              :precision="2"
              append="天"
              :min="-99999999999999999"
              :max="99999999999999999"
            ></inputNumber>
            <template slot="label">
              <el-tooltip placement="top" effect="dark">
                <span ::class="{ propClass: tipText1>propLength }">最晚开票日</span>
                <div slot="content" v-html="tipText3"></div>
              </el-tooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结算日" prop="settlementDate" :span="6">
            <el-select v-model="form.settlementDate" placeholder="请选择">
              <el-option
                v-for="item in dictListMap?.settlementDate"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <template slot="label">
              <el-tooltip placement="top" effect="dark">
                <span ::class="{ propClass: tipText1>propLength }">结算日</span>
                <div slot="content" v-html="tipText4"></div>
              </el-tooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="逾期周期" prop="overduePeriod" :span="6">
            <inputNumber
              v-model="form.overduePeriod"
              :controls="false"
              class="inputWidth"
              :precision="2"
              append="天"
              :min="-99999999999999999"
              :max="99999999999999999"
            ></inputNumber>
            <template slot="label">
              <el-tooltip placement="top" effect="dark">
                <span ::class="{ propClass: tipText1>propLength }">逾期周期</span>
                <div slot="content" v-html="tipText4"></div>
              </el-tooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import BaseInfoMixin from './../BaseInfoMixin.js';
  import { baseForm, baseFormRule } from './index.js';
  import saleAgreementCreationMixin from '../../saleAgreementCreationMixin';
  export default {
    name: 'BaseInfoContract',
    mixins: [BaseInfoMixin, saleAgreementCreationMixin],
    props: {
      contractTotalAmount: {
        type: Number,
        default: 0,
      },
      contractStatus: {
        type: String,
        default: '',
      },
      // 远程获取数据反填表单上面
      fetchData: {
        type: Object,
        default: () => {},
      },
      // 是否定量
      disabledIsRestrict: {
        type: Boolean,
        default: false,
      },
      purchaseQuantity: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        // form: {},
        propLength: 13,
        tipText1: '业务员选择最晚日期后，到日期<br>后系统在首页进行提醒-出库', //最晚提货日
        tipText2:
          '业务员填写最晚结算日天数后，进行<br>出库操作工作后，若经过填写天数<br>后，未进行结算操作，系统在首页进行提醒-应收结算单', //最晚应收结算日
        tipText3:
          '业务员填写最晚开票日天数后，进行结算<br>操作动作后，经过填写天数后，未进行开票<br>操作，系统在首页进行提醒-开票', //最晚开票日
        tipText4: '业务员选择结算日后，填写逾期<br>周期后，到日期后系统在首页进行<br>提醒-收款', //回票日期
        isDisabledForm: false,
      };
    },
    computed: {
      formRules() {
        return baseFormRule(this);
      },
      formColumn: {
        set(val) {
          console.log(val);
        },
        get() {
          // return baseForm(this, this.contractStatus);
          return this._getStatusRelatedBaseForm();
        },
      },
      rules() {
        return {};
      },
    },
    methods: {
      _getStatusRelatedBaseForm() {
        let tableColumns = baseForm(this);

        let cs = this.contractStatus;

        let disabledList = ['contractNo', 'projectName', 'contractTotalAmount', 'isFixedPrice'];
        if (cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061') {
          disabledList = disabledList.concat([
            'contractName',
            'customerName',
            'projectInitiationNo',
            'contractBusinessDepartment',
            'contractCurrency',
            //wumaoFix
            'pricingRule',
            //wumaoFix
            'externalContractNo',
          ]);
        }

        if (cs == 'ZT02' || (cs == 'ZT03' && cs != 'ZT061') || cs == 'ZT023') {
          disabledList.push('contractBusinessCompanyNo');
        }

        if (this.baseFormData.contractBusinessCompanyNo == '') {
          disabledList.push('contractBusinessDepartment');
        }

        if (!this.baseFormData.projectInitiationNo || this.baseFormData.projectInitiationNo == '') {
          disabledList.push('platformCompanyFileNo');
        }

        if (this.disabledIsRestrict) {
          disabledList.push('isRestrict');
        }

        if (this.baseFormData.isDefault != '1') {
          disabledList = disabledList.concat([
            'liquidatedDamagesType',
            'liquidatedFixedValue',
            'liquidatedInterestRate',
            'qualityGuaranteeDepositMethodCode',
            'chargeFixedValue',
            'chargeProportion',
            'qualityGuaranteeDepositOverdue',
          ]);
        }

        if (this.baseFormData.liquidatedDamagesType != 'FIXED') {
          disabledList.push('liquidatedFixedValue');
        }
        if (this.baseFormData.liquidatedDamagesType != 'RATE') {
          disabledList.push('liquidatedInterestRate');
        }

        if (this.baseFormData.qualityGuaranteeDepositMethodCode != 'FIXED') {
          disabledList.push('chargeFixedValue');
        }
        if (this.baseFormData.qualityGuaranteeDepositMethodCode != 'RATE') {
          disabledList.push('chargeProportion');
        }

        if (
          !this.baseFormData.qualityGuaranteeDepositMethodCode ||
          this.baseFormData.qualityGuaranteeDepositMethodCode == ''
        ) {
          disabledList.push('qualityGuaranteeDepositOverdue');
        }

        // if (
        //   !this.baseFormData.platformCompanyFileNo ||
        //   this.baseFormData.platformCompanyFileNo == ''
        // ) {
        //   disabledList.push('projectInitiationNo');
        // }

        if (cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT061') {
          this.isDisabledForm = true;
          disabledList = disabledList.concat([
            'signDate',
            'contractValidStart',
            'contractValidEnd',
            'isNotEndDate',
            'personChargeName',
            'receiptMethod',
            'contractType',
            'overShippedPercentage',
            'shortShippedPercentage',
            'performanceBondPayMethodCode',
            'performanceBond',
            'warrantyClause',
            'isRestrict',
            'mark',
            'contractBusinessCompanyNo',

            //wumaoFix
            'settlementDate',
            'incomeMethod',
            'isDefault',
            'isLongRange',
            'overduePeriod',
            'liquidatedDamagesType',
            'liquidatedFixedValue',
            'liquidatedInterestRate',
            'qualityGuaranteeDepositMethodCode',
            'chargeFixedValue',
            'chargeProportion',
            'qualityGuaranteeDepositOverdue',
            'marginAmount',
            'businessType',
            'performanceBondRecipient',
          ]);
        }

        return tableColumns.map((item) => {
          if (disabledList.includes(item.prop)) {
            return { ...item, disabled: true };
          }
          if (item.prop == 'platformCompanyFileNo') {
            if (item.type == 'select') {
              let state = cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061';
              return { ...item, disabled: state };
            } else {
              return { ...item, disabled: true };
            }
          }
          return item;
        });
      },
      getformData() {
        return this.form;
      },
    },
    watch: {
      contractTotalAmount: {
        handler(val) {
          console.log('amount changed');
          this.baseFormData = {
            ...this.baseFormData,
            contractTotalAmount: val + '',
            businessContractTotalAmount: val + '',
          };
          this.formColumn = baseForm(this, this.contractStatus);
        },
        immediate: true,
      },
      fetchData: {
        handler(val) {
          if (Object.keys(val).length) {
            let newObj = {};
            for (const key in val) {
              if (typeof val[key] == 'number') {
                newObj[key] = val[key] + '';
              } else {
                newObj[key] = val[key];
              }
            }
            // this.baseFormData = newObj;
            const {
              latestPickUpDate,
              latestReceivableSettlementFate,
              settlementDate,
              overduePeriod,
              latestInvoiceFate,
              // baseFormData,
            } = newObj;
            this.form = {
              latestPickUpDate,
              latestReceivableSettlementFate,
              settlementDate,
              overduePeriod,
              latestInvoiceFate,
            };
            this.baseFormData = newObj;
            console.log(this.form, this.baseFormData, '分割表单字段');
            this.getProjectByProjectNo(this.baseFormData.projectInitiationNo);
          }
        },
        immediate: true,
        deep: true,
      },
      purchaseQuantity: {
        handler(val) {
          this.baseFormData.purchaseQuantity = val + '';
        },
        immediate: true,
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-form-item__label {
    font-size: 13px;
  }
</style>
